<template>
    <div class="match-centre-card" :class="fixture.status">

        <div class="header d-flex justify-content-between" v-if="fixture.status === 'result'">

            <div class="left"></div>

            <div class="center">
                <div class="btn btn-blue mx-auto">
                    <span class="type">
                        RESULT
                    </span>
                </div>
            </div>

            <div class="right">
                <a :href="url + '/' + fixture.id">
                    <img src="/icons/documents-navy.svg" alt="Match Report">
                    Report
                </a>
            </div>
        </div>

        <div class="header" v-if="fixture.status === 'cancelled'">
            <div class="btn btn-danger mx-auto">
                <span class="type">
                    Cancelled
                </span>
            </div>
        </div>

        <div class="header" v-if="['liveWithScore', 'liveNoScore', 'live'].includes(fixture.status)">
            <div class="left">
                <a :href="url + '/' + fixture.id">
                    <img src="/icons/match-centre-navy.svg" alt="View">
                    View
                </a>
            </div>
            <div class="center">
                <div class="btn btn-secondary mx-auto">
                    <span class="type">
                        Live
                    </span>
                    <favourite
                    v-if="user"
                    :hashid="fixture.id"
                    :favouriteUrl="fixture.favourite_url"
                    :listUrl="fixture.list_url"
                    :listProp="favouriteList"
                    inline="true"></favourite>
                    <span class="time">
                        {{fixture.start_time}}
                    </span>
                </div>
            </div>
            <div class="right">
                <a @click="addComment()" class="cursor-pointer">
                    <img src="/icons/add-white.svg" alt="Match Comment">
                    Update
                </a>
            </div>
        </div>

        <div class="header" v-if="fixture.status === 'scheduled'">
            <div class="btn btn-primary mx-auto">
                <span class="type">
                    Scheduled
                </span>
                <favourite
                v-if="user"
                :hashid="fixture.id"
                :favouriteUrl="fixture.favourite_url"
                :listUrl="fixture.list_url"
                :listProp="favouriteList"
                inline="true"></favourite>
                <span class="time">
                    {{fixture.start_time}}
                </span>
            </div>
        </div>

        <div class="content">
            <div class=" team-home">
                <p>
                    <a :href="url + '/' + fixture.id" v-if="fixture.status === 'live' || fixture.status === 'result'">
                        {{fixture.team_home}}
                    </a>
                    <span v-else>{{fixture.team_home}}</span>
                </p>
                <span class="current-score" :class="homeTeamWinLose" v-if="fixture.home_team_score">
                    {{fixture.home_team_score}}
                </span>
                <p v-if="fixture.match_overs && fixture.team_home_overs">
                    ({{ fixture.team_home_overs }} /  {{ fixture.match_overs }}ov.)
                </p>
            </div>
            <div class="versus "><p>  v </p> </div>
            <div class=" team-away">
                <p>
                    <a :href="url + '/' + fixture.id" v-if="fixture.status === 'live' || fixture.status === 'result'">
                        {{fixture.team_away}}
                    </a>
                    <span v-else>{{fixture.team_away}}</span>
                </p>
                <span class="current-score" :class="awayTeamWinLose" v-if="fixture.away_team_score">
                    {{fixture.away_team_score}}
                </span>
                <p v-if="fixture.match_overs && fixture.team_away_overs">
                    ({{ fixture.team_away_overs }} /  {{ fixture.match_overs }}ov.)
                </p>
            </div>

            <div class="col-12 text-center result" v-if="fixture.result">
                {{ fixture.result }}
            </div>

            <div class="col-12 text-center result" v-else>
                <span v-if="fixture.is_dls">(D/L)</span>
            </div>

            <div class="col-12 competition-details" v-if="fixture.competition">
                {{fixture.competition.type + ' | ' + fixture.competition.category + ' | ' + fixture.competition.title}}
            </div>

            <div class="col-12 competition-details" v-else>{{fixture.competition_name}}</div>

            <div class="col-12 text-center">{{fixture.venue}}</div>

            <a @click="updateFixture()" class="cursor-pointer edit-button" v-if="canUpdate">
                <img src="/icons/edit-navy.svg" alt="">
            </a>
        </div>
    </div>
</template>

<script>

import Favourite from '../../Both/Common/Favourite.vue';

export default {
    data() {
        return {
        }
    },

    props: ['fixture', 'url', 'currentTime', 'favouriteList', 'user', 'today', 'roles'],
    mounted() {
        this.getCrickClubsData();
        this.callGetCrickClubsData();
    },
    computed: {
        status: function () {
            if(this.fixture.upcoming) {
                return "scheduled";
            }
            if(this.fixture.result) {
                return 'result';
            }
            if(this.fixture.is_off) {
                return 'cancelled'
            }

            var start_time = parseInt(this.fixture.start_time.split(':').join(''), 10);
            var currentTime = parseInt(this.currentTime.split(':').join(''), 10);


            if (currentTime > start_time && currentTime < (start_time + 800)) {
                return 'live';
            } else if(currentTime > (start_time + 800)){
                return 'result';
            }
            return 'scheduled';
        },
        canUpdate: function () {
            var update = false;
            this.roles.forEach(element => {
                if(element === 'Cricket Leinster Administrator' || element === 'Match Centre Editor') {
                    update = true;
                }
            });
            return update;
        },
        homeTeamWinLose : function() {
            return {
                win : this.winLose('win', this.fixture.team_home),
                lose: this.winLose('lose', this.fixture.team_home),
            }
        },
        awayTeamWinLose : function() {
            return {
                win : this.winLose('win', this.fixture.team_away),
                lose: this.winLose('lose', this.fixture.team_away),
            }
        }
    },
    methods: {
        addComment () {
            this.$emit('comment', this.fixture.id);
        },
        updateFixture () {
            this.$emit('update', this.fixture, 'index');
        },
        forceUpdate() {
            this.getCrickClubsData();
        },
        getCrickClubsData() {
            var self = this
            // var url = this.commentsUrl + '/storage/match-centre/' + this.fixture.hashid + '/match-data.json'
            // $.getJSON(url, function(data) {
            //     self.data = data;
            // });
        },
        callGetCrickClubsData() {
            var self = this;
            setTimeout(function(){
                self.getCrickClubsData();
                self.callGetCrickClubsData();
            }, 60000);
        },
        winLose(type, team)
        {
            if (!this.fixture.team_win_title
                || !(this.fixture.team_home == this.fixture.team_win_title
                        || this.fixture.team_away == this.fixture.team_win_title)) {
                return false;
            }

            if (team == this.fixture.team_win_title && type == 'win') {
                return true;
            }

            if (team != this.fixture.team_win_title && type == 'lose') {
                return true;
            }

            return false;
        }
    },
    components: {
        Favourite,
    }
}
</script>
